import { z } from "zod";
import { CITIES } from "../types/domain.js";

export const eventTitleSchema = z.string().trim().min(3, "Название слишком короткое").max(80, "Слишком длинное");
export const eventDescriptionSchema = z.string().trim().max(800, "Описание слишком длинное").optional();
export const eventVenueNameSchema = z.string().trim().min(2, "Укажи место").max(80);
export const eventVenueAddressSchema = z.string().trim().max(200).optional();
export const eventCitySchema = z.enum(CITIES);
// Format is one of the predefined slugs OR a custom free-text label the host
// typed via the "Other" option. Stored as text; the UI shows known slugs
// translated and custom values verbatim.
export const eventFormatSchema = z.string().trim().min(1, "Выбери формат").max(40, "Слишком длинный формат");
export const eventStartsAtSchema = z
  .string()
  .refine((s) => !Number.isNaN(Date.parse(s)), "Невалидная дата")
  .refine((s) => Date.parse(s) > Date.now() + 30 * 60 * 1000, "Встреча должна быть минимум через 30 минут");
export const eventDurationSchema = z.number().int().min(30).max(480);
export const eventCapacitySchema = z.number().int().min(2).max(50).optional();

export const eventLatSchema = z.number().min(-90).max(90).optional();
export const eventLngSchema = z.number().min(-180).max(180).optional();

export const userEventSchema = z.object({
  title: eventTitleSchema,
  description: eventDescriptionSchema,
  venue_name: eventVenueNameSchema,
  venue_address: eventVenueAddressSchema,
  city: eventCitySchema,
  format: eventFormatSchema,
  starts_at: eventStartsAtSchema,
  duration_minutes: eventDurationSchema.default(90),
  capacity: eventCapacitySchema,
  lat: eventLatSchema,
  lng: eventLngSchema,
});

export type UserEventInput = z.infer<typeof userEventSchema>;
